import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { FiscalNoteFileType } from '@/types'
import { AxiosError } from 'axios'

type DownloadFiscalNoteParams = {
  file_type: FiscalNoteFileType
  fiscal_note_key: string
}

export async function downloadFiscalNote({
  file_type,
  fiscal_note_key,
}: DownloadFiscalNoteParams) {
  const response = await httpClient('accounting-dealer').get<string>(
    `/v3/fiscal-note/${fiscal_note_key}/file/${file_type}`,
  )

  return response.data
}

export function useDownloadFiscalNote(
  options?: UseMutationOptions<
    string,
    AxiosError,
    DownloadFiscalNoteParams,
    unknown
  >,
) {
  return useMutation({
    mutationFn: downloadFiscalNote,
    ...options,
  })
}
